import { PageContainer } from "@volca/ui/components/ui/page-components";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { RosterTableSkeleton } from "@/payroll/roster/roster-table-skeleton";
import { AccessHeader } from "./access-header";

export const WorkbookAccessLoadingState = () => (
  <PageContainer variant="workspace" aria-busy="true">
    <span className="sr-only">Loading workbook access</span>
    <AccessHeader />
    <Stack align="start" gap={4} className="min-h-0 w-full flex-1">
      <Stack direction="row" gap={4} className="w-full border-b pb-2">
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-5 w-32" />
      </Stack>
      <RosterTableSkeleton />
    </Stack>
  </PageContainer>
);
